module.exports = __webpack_public_path__ + "static/squirrelSketch-9f5fbe5ed856225b941fcbce46892361.png";